<template>
    <div class="animated fadeIn" v-if="satisfiedDependencies">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-commenting text-primary mr-2"></i>
                    Nueva Consulta
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">

            <b-col sm="12" md="6">
                <b-card>
                    <query-form
                        :emitSubmitEvent="submitQueryForm"
                        :headquarters="authUser().headquarters"
                        :clientHeadquarter="!!client ? client.headquarters : null"
                        :initial-query="query"
                        @submit-query-form="addQuery($event)">
                    </query-form>

                    <b-row v-if="mixinCheckPermission('QUERY_NEW')" class="flex-row-reverse px-3 mb-1 mt-2">
                        <button
                            :disabled="!client"
                            class="btn btn-brand btn-primary btn-lg"
                            @click="submitQueryForm=true">
                            Guardar
                        </button>
                    </b-row>

                </b-card>
            </b-col>

            <b-col sm="12" md="6">

                <b-tabs v-model="tabIndex">
                    <b-tab title="Socios" no-body>
                        <b-row class="px-2 pt-2">
                            <member-search-small @submit-member="setMember($event)"></member-search-small>
                        </b-row>

                        <b-row v-if="!!client && clientType === 'member'" class="animated fadeIn px-4 pt-3 pb-2">
                            <member-summary :member="client" :headquarters="client.headquarters"></member-summary>
                        </b-row>
                    </b-tab>

                    <b-tab title="No Socios">
                        <b-row class="px-2 pt-2">
                            <client-search-small @submit-client="setClient($event)"></client-search-small>
                        </b-row>

                        <b-row v-if="!!client && clientType==='client'" class="animated fadeIn px-4 pt-3 pb-2">
                            <client-summary :client="client"></client-summary>
                        </b-row>
                    </b-tab>

                    <b-tab title="Nuevo Interesado" v-if="mixinCheckPermission('CLIENT_NEW')">
                        <b-row class="px-2 py-2" v-if="tabIndex===2">
                            <client-form
                                :cnaes="cnaes"
                                :renderSaveButton="true"
                                @submit-client="createClient($event)">
                                Crear
                            </client-form>
                        </b-row>
                    </b-tab>
                </b-tabs>

            </b-col>
        </b-row>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import QueryForm from './QueryForm';
    import MemberSearchSmall from '@/components/clients/members/MemberSearchSmall';
    import MemberSummary from '@/components/clients/members/MemberSummary';
    import ClientSearchSmall from '@/components/clients/ClientSearchSmall';
    import ClientSummary from '@/components/clients/ClientSummary';
    import ClientForm from '@/components/clients/ClientForm';
    import {createQuery} from '@/api/query-api';
    import {getCnaes} from '@/api/cnae-api';
    import {createClient} from '@/api/client-api';
    import {getQuery} from "@/api/query-api";

    export default {
        name: 'add-query',
        components: {
            QueryForm,
            MemberSearchSmall,
            MemberSummary,
            ClientSearchSmall,
            ClientSummary,
            ClientForm
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    }
                ],
                tabIndex: 0,
                client: null,
                clientType: null,
                cnaes: null,
                submitQueryForm: false,
                query: null,
            }
        },
        computed: {
            satisfiedDependencies() {
                return (!!this.cnaes);
            }
        },

        mounted() {
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getCnaes();
            if (this.$route.query.originQueryId) {
                this.getOriginQuery(this.$route.query.originQueryId, this.$route.query.status);
            }
        },

        methods: {

            ...mapGetters([
                'authUser',
            ]),

            async getOriginQuery(originQueryId, status) {
                this.$_loadingMixin_showLoading();
                await getQuery(originQueryId)
                    .then((query) => {
                        this.query = query;
                        this.query.status = status;
                        this.query.originQueryId = originQueryId;
                        this.client = this.query.client;
                        this.clientType = this.query.client.class.toLowerCase();
                        if (this.clientType === 'client') {
                            this.tabIndex = 1;
                        }
                    });
                this.$_loadingMixin_hideLoading();
            },

            async getCnaes() {
                this.$_loadingMixin_showLoading();
                await getCnaes()
                    .then((cnaes) => {
                        this.cnaes = cnaes;
                    })
                    .catch(() => {
                        this.cnaes = [];
                    });
                this.$_loadingMixin_hideLoading();
            },
            validateQuery(query) {
                return (
                    query.categoryAdvisers.length > 0
                    && !!query.headquarters
                    && !!query.headquarters.uuid
                    && !!query.client
                    && !!query.client.uuid
                    && !!query.description
                    && !!query.origin
                    && !!query.date
                );
            },
            addQuery(query) {
                let resultClient = JSON.parse(JSON.stringify(this.client));
                if (resultClient.hasOwnProperty('unlinkedMember') && resultClient.unlinkedMember && resultClient.uuid && resultClient.unlinkedMember.uuid) {
                    resultClient.uuid = resultClient.unlinkedMember.uuid;
                }

                let queryObject = Object.assign({}, query, {client: resultClient});
                if (this.validateQuery(queryObject)) {
                    this.addQueryRequest(queryObject)
                } else {
                    this.$_notificationMixin_error('La datos no son válidos', 'Revise la consulta para que no falte ningún dato obligatorio')
                }
                this.submitQueryForm = false;
            },
            async addQueryRequest(query) {
                this.$_loadingMixin_showLoading();
                await createQuery(
                    query.categoryAdvisers.map((item) => {
                        return {
                            categoryId: item.category.uuid,
                            adviserId: item.adviser.uuid
                        }
                    }),
                    query.headquarters.uuid,
                    query.client.uuid,
                    query.urgent,
                    query.potentialMember,
                    query.description,
                    query.comment,
                    query.origin,
                    query.date,
                    query.associatedProjects,
                    this.$route.query.originQueryId,
                    this.$route.query.status
                )
                    .then(() => {
                        this.$_notificationMixin_success('Operación Completada', 'Realizado con éxito');
                        this.$router.push({path: '/queries/list'});
                    })
                    .catch(() => {
                        this.$_notificationMixin_error('Operación denegada', 'Algo salió mal');
                    });
                this.$_loadingMixin_hideLoading();
            },
            setMember(member) {
                this.client = Object.assign({}, member);
                this.clientType = 'member';
            },
            setClient(client) {
                this.client = Object.assign({}, client);
                this.clientType = 'client';
            },

            showCreateClientError(errorMessage) {
                switch (errorMessage) {
                    case "Client with this NIF already exists":
                        this.$_notificationMixin_error('NIF incorrecto', 'Ya existe un registro con el NIF indicado.');
                        break;
                    case "Client with this phone already exists":
                        this.$_notificationMixin_error('Teléfono incorrecto', 'Ya existe un registro con el teléfono indicado.');
                        break;
                    case "Client with this email already exists":
                        this.$_notificationMixin_error('Email incorrecto', 'Ya existe un registro con el email indicado.');
                        break;
                    default:
                        this.$_notificationMixin_error('Error al registrar un nuevo interesado', 'No se ha podido añadir al nuevo interesado');
                }
            },

            async createClient(client) {
                this.$_loadingMixin_showLoading();

                let parameters = Object.assign({}, client);
                parameters.address.main = true;
                parameters.address.name = 'Principal';
                parameters.companyName = client.company.name;
                parameters.companyCif = client.company.cif;
                parameters.companyNumberOfWorkers = client.company.numberOfWorkers;
                parameters.cnaes = client.cnaes.map(cnae => (cnae.uuid));

                await createClient(parameters)
                    .then((clientCreated) => {
                        this.$_notificationMixin_success('Operación Completada', 'Nuevo interesado creado con éxito');
                        this.setClient(clientCreated);
                        this.tabIndex = 1;
                    })
                    .catch((error) => {
                        this.showCreateClientError(error.response.data);
                    });
                this.$_loadingMixin_hideLoading();
            }
        }
    }
</script>

<style scoped>

</style>
